import * as __WEBPACK_EXTERNAL_MODULE__mask_mjs_214f17a5__ from "./mask.mjs";
const createActionTransformer = ({ actionTransformer, redactedFields })=>(action)=>{
        const actionType = action.type ?? '';
        if (actionType.includes('ANALYTIC')) return null;
        const transformedAction = actionTransformer ? actionTransformer(action) : action;
        if (!transformedAction) return null;
        const rawPatterns = (redactedFields?.action ?? []).filter((it)=>'string' == typeof it || it.type === actionType).map((it)=>'string' == typeof it ? it : it.pattern);
        const patternsFromStore = 'SET_FIELD_DATA_AS_IS' === actionType ? (redactedFields?.store ?? []).map((pattern)=>`payload.${pattern}`) : [];
        return (0, __WEBPACK_EXTERNAL_MODULE__mask_mjs_214f17a5__.maskMany)(transformedAction, __WEBPACK_EXTERNAL_MODULE__mask_mjs_214f17a5__.genericLengthStubber, [
            ...rawPatterns,
            ...patternsFromStore
        ]);
    };
export { createActionTransformer };

//# sourceMappingURL=actionTransformer.mjs.map